
export const BASE_DOKOUN_API_URL = process.env.VUE_APP_DOKOUN_API
